
import { defineComponent, reactive } from "vue";
import { Equipment } from "@/const/equips/equipmentType";
import { equipGradeName, equipTypesNames } from "@/const/equips/equipConst";
const EquipTooltip = defineComponent({
  name: "EquipTooltip",
  props: {
    equip: {
      type: [Equipment, Object],
      require: true
    },
    isWear: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const gradeName = reactive(equipGradeName);
    const typesNames = reactive(equipTypesNames);
    return {
      gradeName,
      typesNames
    };
  }
});
export default EquipTooltip;
